/*!

=========================================================
* Material Dashboard PRO React - v1.7.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import IngresoSistema from "conten/ingresoSistema/IngresoSistema";
import TerminosYCondiciones from "conten/terminosYCondiciones/TerminosYCondiciones";

var authRoutes = [
  {
    path: "/ingreso-sistema",
    name: "Ingreso al sistema",
    mini: "IS",
    component: IngresoSistema,
    layout: "/auth"
  },
   {
    path: "/terminos-y-condiciones/:id",
    name: "Terminos y condiciones",
    mini: "TC",
    component: TerminosYCondiciones,
    layout: "/auth"
  },
];
export default authRoutes;
